import { icons } from './constant';

// ==============================|| PRODUCT MENU ITEMS ||============================== //

const regulatedEntity = {
	id: 'regulated_entity',
	title: 'Regulated Entity',
	type: 'collapse',
	icon: icons.GavelIcon,
	children: [
		{
			id: 'domains',
			title: 'Domains',
			type: 'item',
			url: '/domains',
			icon: icons.DomainIcon,
			breadcrumbs: true,
		},
		{
			id: 'lenders',
			title: 'Lenders',
			type: 'item',
			url: '/lenders',
			icon: icons.AccountBalanceOutlinedIcon,
			breadcrumbs: true,
		},
	],
};

export default regulatedEntity;
